import React from 'react';
import './HowItWorksSection.css'; // Create this CSS file next

const HowItWorksSection = () => {
  return (
    <section className="how-it-works-section section" id="how-it-operate">
      <div className="container">
        <h2>How we operate</h2>
        <div className="steps-container">
          <div className="step-item">
            <div className="step-icon">1</div> {/* Placeholder icon/number */}
            <h3>Submit your order</h3>
            <p>Use our contact form to submit your order, and we'll get back to you as soon as possible to discuss all details.</p>
          </div>
          <div className="step-line"></div> {/* Line connecting steps */}
          <div className="step-item">
            <div className="step-icon">2</div> {/* Placeholder icon/number */}
            <h3>Proceed with the payment</h3>
            <p>Choose a payment method that works best for you. We'll begin working on your order after successful payment.</p>
          </div>
           <div className="step-line"></div> {/* Line connecting steps */}
          <div className="step-item">
            <div className="step-icon">3</div> {/* Placeholder icon/number */}
            <h3>Enjoy the results</h3>
            <p>Enjoy your new website that works for your business and your customers while bringing great results.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection; 